// extracted by mini-css-extract-plugin
export default {"root":"BackToLink_root__SVh-L"};